import { IPreloadedState } from 'shared/types/redux';

export const selectAdfoxPuids = (state: IPreloadedState) => state.adfoxPuids;
